import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const navigationItems = [
  { name: 'About', href: '/about' },
  { name: 'Use Cases', href: '/use-cases' },
  { name: 'Custom Solutions', href: '/custom-solutions' },
  { name: 'Industries', href: '/industries' },
  { name: 'Case Studies', href: '/case-studies' },
  { name: 'Contact', href: '/contact' }];


  return (
    <header className="bg-background/95 backdrop-blur-sm border-b border-border sticky top-0 z-50 shadow-sm layout-stable" data-id="qpixwpuqq" data-path="src/components/navigation/Header.tsx">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="u59zpr210" data-path="src/components/navigation/Header.tsx">
        <div className="flex justify-between items-center h-16" data-id="uok9b53ov" data-path="src/components/navigation/Header.tsx">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="ge2b09zxw" data-path="src/components/navigation/Header.tsx">
            <Logo variant="full" data-id="hdodjbebc" data-path="src/components/navigation/Header.tsx" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1" data-id="c80lnl4pt" data-path="src/components/navigation/Header.tsx">
            {/* Regular Navigation Items */}
            {navigationItems.map((item) =>
            <Link
              key={item.name}
              to={item.href}
              className={`px-4 py-2 text-sm font-medium rounded-lg nav-transition ${
              location.pathname === item.href ?
              "text-primary-foreground bg-primary shadow-lg" :
              "text-muted-foreground hover:text-foreground hover:bg-accent"}`
              } data-id="nexuuxry9" data-path="src/components/navigation/Header.tsx">

                {item.name}
              </Link>
            )}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex" data-id="y5wm6uzg8" data-path="src/components/navigation/Header.tsx">
            <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground font-medium px-6 py-2 rounded-lg shadow-lg hover:shadow-xl nav-transition" data-id="ufpoqtlno" data-path="src/components/navigation/Header.tsx">
              <Link to="/contact" data-id="oy6if25v6" data-path="src/components/navigation/Header.tsx">Book a Demo</Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center" data-id="aeinvbhwm" data-path="src/components/navigation/Header.tsx">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-accent nav-transition" data-id="y006kj24j" data-path="src/components/navigation/Header.tsx">

              {isMenuOpen ?
              <X className="block h-6 w-6" aria-hidden="true" data-id="mxmt9udww" data-path="src/components/navigation/Header.tsx" /> :

              <Menu className="block h-6 w-6" aria-hidden="true" data-id="ry2giiuvy" data-path="src/components/navigation/Header.tsx" />
              }
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen &&
      <div className="lg:hidden bg-background border-t border-border shadow-lg layout-stable" data-id="jxj7tjtgy" data-path="src/components/navigation/Header.tsx">
          <div className="px-4 pt-4 pb-6 space-y-2" data-id="3ah18x4rh" data-path="src/components/navigation/Header.tsx">
            {/* Regular Navigation Items for Mobile */}
            <div data-id="hel5odaw2" data-path="src/components/navigation/Header.tsx">
              {navigationItems.map((item) =>
            <Link
              key={item.name}
              to={item.href}
              className={`block px-3 py-3 text-base font-medium rounded-md nav-transition ${
              location.pathname === item.href ?
              "text-primary-foreground bg-primary shadow-lg" :
              "text-muted-foreground hover:text-foreground hover:bg-accent"}`
              }
              onClick={() => setIsMenuOpen(false)} data-id="rru7tqw1j" data-path="src/components/navigation/Header.tsx">

                  {item.name}
                </Link>
            )}
            </div>

            {/* CTA Button for Mobile */}
            <div className="pt-4 border-t border-border" data-id="c4pj4rer5" data-path="src/components/navigation/Header.tsx">
              <Button asChild className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-medium py-3 rounded-lg shadow-lg hover:shadow-xl nav-transition" data-id="hb72iwozk" data-path="src/components/navigation/Header.tsx">
                <Link to="/contact" data-id="y0hln4otl" data-path="src/components/navigation/Header.tsx">Book a Demo</Link>
              </Button>
            </div>
          </div>
        </div>
      }
    </header>);

}